import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect, useContext } from "react";
import { ApisValue } from "./apis";
import { DatabaseValue } from "./database";
import __types from "../utils/types";
export const TypesValue = createContext(null);
export const TypesDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  } else {
    return newState;
  }
};

export default function TypesContext({ children }) {
  const [state, dispatch] = useReducer(reducer, __types);
  const apisValue = useContext(ApisValue);
  const databaseValue = useContext(DatabaseValue);
  const { appId } = useParams();

  useEffect(() => {
    const getTypes = async () => {
      //Database Types
      const _databaseTypes = databaseValue.map((table) => {
        return {
          name: table.id,
          category: "database",
          sqlType: "character varying",
          fields: table.fields,
          displayName: table.name,
        };
      });
      //API Types
      const _apiTypes = [];
      apisValue.map((t) => {
        t.calls
          .filter((x) => !!x.schema)
          .map((c) => {
            const parseTypes = (s) => {
              if (!!s.fields) {
                _apiTypes.push({
                  name: s.type,
                  category: "api",
                  sqlType: "jsonb",
                  fields: s.fields,
                  displayName: s.type,
                });
                Object.keys(s.fields).forEach((k) => {
                  parseTypes(s.fields[k]);
                });
              }
            };
            parseTypes(c.schema);
          });
      });

      const finalTypes = [...__types, ..._apiTypes, ..._databaseTypes];
      dispatch({ type: "set", value: finalTypes });
    };
    getTypes();
  }, [apisValue, databaseValue]);

  return (
    <TypesValue.Provider value={state}>
      <TypesDisbatch.Provider value={dispatch}>
        {children}
      </TypesDisbatch.Provider>
    </TypesValue.Provider>
  );
}
